import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
 selector: 'iho-discover-and-earn',
 standalone: true,
 imports: [CommonModule],
 templateUrl: './discover-and-earn.component.html',
 styleUrls: ['./discover-and-earn.component.scss'],
})
export class DiscoverAndEarnComponent {
    imageSrc = '/assets/images/discoverAndEarn.png';
}
